(function () {
  const MIN_DESKTOP_WIDTH = 990;
  const MIN_SCROLL_HEIGHT = 180;
  const BOTTOM_GAP = 20;
  const DEFAULT_MAX_HEIGHT = 360;

  function resetDescription(description) {
    description.classList.remove('product__description--scrollable');
    description.style.removeProperty('--product-description-max-height');
  }

  function syncProductDescriptionHeight(root) {
    const product = root.closest('.product') || root.querySelector('.product');
    const mediaContent =
      product &&
      (product.querySelector('.product__media-wrapper media-gallery') ||
        product.querySelector('.product__media-wrapper .product__media-list') ||
        product.querySelector('.product__media-wrapper'));
    const description = product && product.querySelector('[data-product-description-scroll]');

    if (!product || !mediaContent || !description) {
      return;
    }

    if (window.innerWidth < MIN_DESKTOP_WIDTH) {
      resetDescription(description);
      return;
    }

    const mediaRect = mediaContent.getBoundingClientRect();
    const descriptionRect = description.getBoundingClientRect();
    const mediaBottom = mediaRect.top + window.scrollY + mediaRect.height;
    const descriptionTop = descriptionRect.top + window.scrollY;
    const availableHeight = Math.floor(mediaBottom - descriptionTop - BOTTOM_GAP);
    const maxHeight =
      availableHeight >= MIN_SCROLL_HEIGHT
        ? Math.min(availableHeight, DEFAULT_MAX_HEIGHT)
        : DEFAULT_MAX_HEIGHT;

    description.style.setProperty('--product-description-max-height', `${maxHeight}px`);

    if (description.scrollHeight > maxHeight + 8) {
      description.classList.add('product__description--scrollable');
    } else {
      description.classList.remove('product__description--scrollable');
    }
  }

  function bindProductDescriptionSync(productInfo) {
    if (!productInfo || productInfo.dataset.descriptionScrollBound === 'true') {
      return;
    }

    productInfo.dataset.descriptionScrollBound = 'true';
    const run = () => syncProductDescriptionHeight(productInfo);
    const mediaContent =
      productInfo.querySelector('.product__media-wrapper media-gallery') ||
      productInfo.querySelector('.product__media-wrapper .product__media-list') ||
      productInfo.querySelector('.product__media-wrapper');
    const description = productInfo.querySelector('[data-product-description-scroll]');

    if (!mediaContent || !description) {
      return;
    }

    const debouncedRun = () => window.requestAnimationFrame(run);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(debouncedRun);
      observer.observe(mediaContent);
      observer.observe(description);
    }

    window.addEventListener('resize', debouncedRun, { passive: true });
    window.addEventListener('load', debouncedRun, { passive: true });
    document.addEventListener('shopify:section:load', debouncedRun);
    document.addEventListener('shopify:section:reorder', debouncedRun);

    run();
  }

  function init() {
    document.querySelectorAll('product-info').forEach(bindProductDescriptionSync);
  }

  function bindHomepageReviewCarousel() {
    const homepageFeed = document.querySelector('.template-index .etsy-review-feed');
    if (!homepageFeed) {
      return;
    }

    if (homepageFeed.querySelector('[data-etsy-carousel]')) {
      return;
    }

    const viewport = homepageFeed.querySelector('.etsy-review-feed__grid');
    const header = homepageFeed.querySelector('.etsy-review-feed__header');

    if (!viewport || !header || viewport.dataset.carouselBound === 'true') {
      return;
    }

    viewport.dataset.carouselBound = 'true';
    let controls = homepageFeed.querySelector('.etsy-review-feed__controls');

    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'etsy-review-feed__controls';
      controls.innerHTML = `
        <button class="etsy-review-feed__control" type="button" aria-label="Scroll reviews left" data-etsy-carousel-prev>
          <span aria-hidden="true">&#8592;</span>
        </button>
        <button class="etsy-review-feed__control" type="button" aria-label="Scroll reviews right" data-etsy-carousel-next>
          <span aria-hidden="true">&#8594;</span>
        </button>
      `;
      header.appendChild(controls);
    }

    const prevButton = controls.querySelector('[data-etsy-carousel-prev]');
    const nextButton = controls.querySelector('[data-etsy-carousel-next]');

    if (!prevButton || !nextButton) {
      return;
    }

    const getScrollAmount = () => {
      const firstCard = viewport.querySelector('.etsy-review-feed__card');
      const gap = parseFloat(window.getComputedStyle(viewport).columnGap || window.getComputedStyle(viewport).gap || '18');
      if (!firstCard) {
        return viewport.clientWidth * 0.9;
      }
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateControls = () => {
      const maxScroll = viewport.scrollWidth - viewport.clientWidth - 4;
      prevButton.disabled = viewport.scrollLeft <= 4;
      nextButton.disabled = viewport.scrollLeft >= maxScroll;
    };

    prevButton.addEventListener('click', () => {
      viewport.scrollBy({ left: getScrollAmount() * -1, behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      viewport.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        init();
        bindHomepageReviewCarousel();
      },
      { once: true }
    );
  } else {
    init();
    bindHomepageReviewCarousel();
  }
})();
